import { Popup } from "./popup";
import { StringBoolean } from "./utils";

const multyBuy = {
  priceEl: document.getElementById("componentPrice"),
  price: 0,
  components: document.querySelectorAll(
    ".jsComponentCard"
  ) as NodeListOf<HTMLElement>,
  buttonText: {
    add: "Add to Bundle",
    remove: "Remove",
  },
  init() {
    const popup = new Popup("#jsComponents", ".jsComponentsOpen", ".jsClose");
    popup.init();
    this.initPrice();
    this.addToBunndle();
  },
  initPrice() {
    if (this.priceEl) {
      const startPrice = this.priceEl.dataset.price as string;
      this.price = +startPrice;
      this.setPrice();
    }
  },
  setPrice() {
    if (this.priceEl) {
      this.priceEl.innerText = "$" + this.price.toFixed(2);
    }
  },
  addToBunndle() {
    this.components.forEach((item) => {
      const btn = item.querySelector(".jsComponentBtn") as HTMLElement | undefined;
      const input = item.querySelector(".jsComponentInput") as
        | HTMLInputElement
        | undefined;
      if (btn && input) {
        btn.addEventListener("click", () => {
          const itemPrice = btn.dataset.price as string;

          if (btn.dataset.added === StringBoolean.FALSE) {
            btn.dataset.added = StringBoolean.TRUE;
            this.price += +itemPrice;
            btn.innerText = this.buttonText.remove;
            btn.classList.add("activeClass");
            input.value = "1";
          } else {
            btn.dataset.added = StringBoolean.FALSE;
            this.price += -itemPrice;
            btn.innerText = this.buttonText.add;
            btn.classList.remove("activeClass");
            input.value = "0";
          }
          this.setPrice();
        });
      }
    });
  },
};

export default multyBuy;